import React from 'react';

import {
  clearIPsError,
  fetchIPs,
  receivePagination,
  receiveTableFilters,
  receiveTableSorting,
} from '../../../redux/actions/Ip';
import {
  filterValuesSelector,
  ipsSelector,
  ipsErrorMsgSelector,
  metaSelector,
  paginationSelector,
  sortingSelector,
  tableQuerySelector,
} from '../../../selectors/ipSelectors';
import IPsTable, { getRows, TABLE_FILTERS as tableFilters }
  from './IPsTable';
import TableContainerLarge from './common/TableContainerLarge';

const URL_SECOND_LEVEL = 'ips';

const IPs = () => (
  <div>
    <TableContainerLarge
      clearErr={clearIPsError}
      dataSelector={ipsSelector}
      errorMessageSelector={ipsErrorMsgSelector}
      fetchData={fetchIPs}
      filtersSelector={filterValuesSelector}
      getRows={getRows}
      metaSelector={metaSelector}
      paginationSelector={paginationSelector}
      receivePagination={receivePagination}
      secondLevel={URL_SECOND_LEVEL}
      setFilter={receiveTableFilters}
      setSorting={receiveTableSorting}
      sortingSelector={sortingSelector}
      Table={IPsTable}
      tableFilters={tableFilters}
      tableQuerySelector={tableQuerySelector}
      titleStr="IP Addresses"
    />
  </div>
);

export default IPs;
